import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Toggle from 'components/Toggle';

const Container = styled.div`
	padding: 40px 0 0;
`;

const Label = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const Logo = props => {
	const { t } = props;

	return (
		<Container>
			<Label>{t('brochure/Controls/Page/Sponda logo')}</Label>
			<Toggle
				isOn={props.logo}
				onChange={checked => {
					props.updatePageSettingsHandler({
						logo: checked,
					})
				}}
			/>
		</Container>
	)
}

Logo.propTypes = {
	t: PropTypes.func,
	logo: PropTypes.bool,
	updatePageSettingsHandler: PropTypes.func,
}

export default translate('translations')(Logo)
